import React from 'react';
import { links } from '../siteData';
import Icon from './Icon';
import { ExternalLink } from './Shared';
import './FarmFeature.css';

export default function FarmFeature() {
  return <aside id="farm-community" className="farm-feature" aria-labelledby="farm-feature-title">
    <div className="farm-feature-heading">
      <img src="/brand/farm-logo.png" alt="Farmers Union" width="64" height="64" loading="lazy" />
      <div><p className="eyebrow">Connected communities</p><h3 id="farm-feature-title">Part of the <span>$FARM</span> ecosystem</h3></div>
    </div>
    <p className="farm-feature-description">ULTRA $MAGA was among the early Cropdusting participants in Farmers Union’s XRPL community. Cropdustings introduce projects to $FARM holders through token airdrops.</p>
    <div className="farm-feature-bottom">
      <p className="farm-feature-date"><Icon name="check" /><span>Our Cropdusting: <time dateTime="2025-06-03">June 3, 2025</time></span></p>
      <ExternalLink href={links.farm} className="farm-feature-link">Explore Farmers Union <Icon name="external" /></ExternalLink>
    </div>
  </aside>;
}
